import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FeeAdjustmentsModel} from '../models/fee-adjustments.model';
import {FeeScheduleService} from '../services/fee-schedule.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-fee-adjustments',
  templateUrl: './fee-adjustments.component.html',
  styleUrls: ['./fee-adjustments.component.scss']
})
export class FeeAdjustmentsComponent implements OnInit {
  isLoading: boolean = false;

  aCbOn: boolean = false;
  bCbOn: boolean = false;
  cCbOn: boolean = false;
  aPCT: number = 0;
  bPCT: number = 0;
  cPCT: number = 0;
  roundingPreference: number = -1;
  roundingDecimalPlace: number = 2;
  feeScheduleID: string;

  constructor(
    public dialogRef: MatDialogRef<FeeAdjustmentsComponent>,
    private feeScheduleService: FeeScheduleService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.feeScheduleID = this.data.DocFeeScheduleID;
  }

  save() {
    const saveModel = new FeeAdjustmentsModel();

    if ((this.aCbOn || this.bCbOn || this.cCbOn) && this.roundingPreference) {
      // error check passed

      // percentage
      if (this.aCbOn && this.aPCT !== 0) {
        saveModel.a = this.aPCT;
      }
      if (this.bCbOn && this.bPCT !== 0) {
        saveModel.b = this.bPCT;
      }
      if (this.cCbOn && this.cPCT !== 0) {
        saveModel.c = this.cPCT;
      }

      // rounding
      if (this.roundingPreference !== -1) {
        saveModel.roundTo = this.roundingPreference;
        if (this.roundingPreference === 1 && this.roundingDecimalPlace) {
          saveModel.decimalPlace = this.roundingDecimalPlace;
        }
      }

      // save on server
      this.feeScheduleService.updateFeeScheduleFeesByPCT(this.feeScheduleID, saveModel)
        .subscribe(response => {
            if (response) {
              this.showMessage('Fee schedule prices updated', 'Success');
              this.close("OK");
            }
          },
          err => {
            // show error
            this.showMessage('Problem updating fee schedule prices', 'Error');
          });
    }
    else {
      this.showMessage('Please complete form', 'Error');
    }
  }

  showMessage(type, message) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top',
      panelClass: ['snackbar-linebreaks']
    });
  }

  close(retVal:  string ) {



    this.dialogRef.close(retVal);
  }

  aChange() {

  }

  bChange() {

  }

  cChange() {

  }

  roundingChange($event: any) {

  }
}
